<template>
  <div>
    <v-card>
      <v-card-title> مدیریت تقاضا </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <trade-response-list></trade-response-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import TradeResponseList from '../components/TradeResponseList.vue';

export default {
  data() {
    return {};
  },
  components: {
    TradeResponseList,
  },
  methods: {},
};
</script>

<style></style>
